var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{staticClass:"my-4 mx-4",attrs:{"width":"500","height":"350","elevation":"5","type":"card-heading, list-item-three-line, list-item-two-line, list-item-two-line"}})}
var staticRenderFns = []

export { render, staticRenderFns }